import NoDataComponent from "./../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const agent_attorney_individs_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Indivdual Agents or Attorneys"
      subheaderinfo="Indivdual Agents or Attorneys will appear here"
    />
  );
};

export default agent_attorney_individs_no_data;